import CurrencyAccordion from './CurrencyAccordion';
import ProcessorAccordion from './ProcessorAccordion';
import type {Metrics} from './types';

const ProcessorMetricsGrouped = ({data}: {data?: Metrics}) => {
  const {groupedByCurrency, groupedByProcessor} = data ?? {};
  if (!groupedByCurrency || !groupedByProcessor) {
    return null;
  }
  return (
    <div className="container mx-auto p-4">
      <div>
        <div>
          <h2 className="text-lg font-bold mb-2">Grouped by Processor</h2>
          <ProcessorAccordion data={groupedByProcessor} />
        </div>
        <div className="mt-8" />
        <div>
          <h2 className="text-lg font-bold mb-2">Grouped by Currency</h2>
          <CurrencyAccordion data={groupedByCurrency} />
        </div>
      </div>
    </div>
  );
};

export default ProcessorMetricsGrouped;
